// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"dd3ca11d","455":"f315f35c","749":"e61955d2","903":"50ee010a","977":"e0328662"}[chunkId] + ".chunk.js";
};